import classnames from 'classnames/bind'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

import RichText from '~/components/Abstracts/RichText'
import InlineCta from '~/components/UI/InlineCta'
import { RichTextBlock } from '~/components/UI/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type QuoteProps = {
  className?: string
  quote?: RichTextBlock
  link?: LinkProps
  cite?: string
}

function Quote({ className, quote, cite, link }: QuoteProps) {
  const quoteStyle = useStyle({
    textPreset: GlobalTextPreset.Text20_24SangBleu,
    textStyling: GlobalTextStyling.Italic,
  })
  const citeStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Grotesk,
  })

  return (
    <blockquote className={cx(css.Quote, className)}>
      <RichText className={cx(css.quote, quoteStyle)} render={quote} />
      {cite && (
        <cite className={cx(css.cite, citeStyle)}>
          <>
            {`- `} {link ? <InlineCta {...link}>{cite}</InlineCta> : cite}
          </>
        </cite>
      )}
    </blockquote>
  )
}

Quote.defaultProps = {}

export default Quote
